










































import { Component, Mixins } from "vue-property-decorator";
import {
  ExistingDocumentEditorMixin,
} from "./mixins";
import DocumentEditor from "../editor/DocumentEditor.vue";
import LoadedDocumentPreprocessor from "./LoadedDocumentPreprocessor.vue";
import { EditingDocument } from "../editor";

@Component({
  components: {
    DocumentEditor,
    LoadedDocumentPreprocessor,
  },
})
export default class ExistingDocumentEditor extends Mixins(ExistingDocumentEditorMixin) {
  $refs!: {
    documentEditor: DocumentEditor
  };

  updateEditingDocument(delegate: (editingDocument: EditingDocument) => void): void {
    this.$refs.documentEditor.updateEditingDocument(delegate);
  }

  async registerDocument(isTemporary: boolean): Promise<number> {
    return this.$refs.documentEditor.registerDocument(isTemporary);
  }

  async cancelEditing(): Promise<void> {
    this.$logger.debug("文書編集中止要求");
    if (this.cancel) {
      await this.$refs.documentEditor.deleteEditToken();
    }
    await this.$refs.documentEditor.deleteWriteToken();
  }
}
